import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { SelectValue } from "@radix-ui/react-select";
import { forwardRef, useCallback } from "react";
import parseDate from "../lib/parseDate";
import { useProjectStoreFormStore } from "../hooks/useProjectStoreFormStore";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useCheckIsProjectLocked } from "../hooks/useCheckIsProjectLocked";

interface PeriodSelectProps {
  options: string[];
  onChange: (value: string) => void;
  value?: string;
  className?: string;
  disableFrom?: string;
  disableTo?: string;
}

export default forwardRef<HTMLButtonElement, PeriodSelectProps>(
  function PeriodSelect(
    { onChange, value, options, className, disableFrom, disableTo },
    ref,
  ) {
    const isSubmitting = useProjectStoreFormStore((s) => s.isSubmitting);
    const { can_update } = useModulePermissions();
    const isProjectLocked = useCheckIsProjectLocked();

    const isPeriodDisabled = useCallback(
      (period: string) => {
        return !!(
          (disableFrom && period < disableFrom) ||
          (disableTo && period > disableTo)
        );
      },
      [disableFrom, disableTo],
    );

    return (
      <Select
        onValueChange={onChange}
        defaultValue={value}
        value={value}
        disabled={isSubmitting || !can_update || isProjectLocked}
      >
        <SelectTrigger ref={ref} className={className}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((period) => (
            <SelectItem
              value={period}
              key={period}
              disabled={isPeriodDisabled(period)}
            >
              {parseDate(period)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  },
);
